import { configureStore } from '@reduxjs/toolkit';
import portfolioSlice from './slices/portfolioSlice';
export const store = configureStore({
    reducer: {
        portfolio: portfolioSlice,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: ['persist/PERSIST'],
        },
    }),
});
